function AboutUs5() {
    return (
    <section data-aos="fade-up" className="flex">
        <div className="w-screen md:min-h-auto" >
            <div className="mx-auto pt-4 md:pt-10 h-full w-auto">
                <h1 className="text-xl text-center font-bold lg:font-extrabold text-[#0139B5] tracking-tight md:text-3xl">
                    <span className="block xl:inline">Founders of ModernVate</span> </h1>
                <div className="md:flex justify-end items-right">
                    <div className="md:grid md:grid-rows-2 gap-10 md:ml-10 md:mr-10">
                        <div data-aos="fade-right" className="md:mt-10 mt-6 md:flex md:justify-left md:items-center">
                            <span className="md:text-xl md:text-left mx-20 text-center md:ml-0  font-bold text-[#EF4A37]">MR. ANIKET MHALA
                                <p className="md:text-lg md:text-left text-center font-semibold md:font-bold text-black">Global Technology Expert & Innovation Leader</p>
                                <div className="flex flex-col md:block   items-center justify-center">
                                    <img
                                        className="w-[4rem] my-4 md:h-32 md:w-32 md:mr-8 md:mt-4  md:float-left "
                                        src="https://i.ibb.co/Tkm6kdB/pfp.png"
                                        alt="Profile" />
                                    <p className="md:text-lg text-sm font-normal px-4 md:px-0 md:pt-6 md:ml-10 md:font-bold text-slate-500 md:tracking-wide md:leading-relaxed md:mr-10">A Strategic & Achievement-oriented
                                        passionate leader, offering 27 years of rich
                                        & multi-functional experience with strong technology & business development
                                        skills and broad multinational experience in delivering IT solutions across
                                        the enterprise by leveraging deep Technology, Innovation, IT advisory
                                        and Hands-On experience.</p>
                                </div>
                            </span>
                        </div>
                        <div data-aos="fade-left" className="md:mt-10 mt-9 md:flex md:justify-left md:items-center ">
                            <span className="md:text-xl md:text-right mx-20 md:ml-0 font-bold text-[#EF4A37]">MR. RANDOM EXPOSES
                                <p className="md:text-lg md:text-right text-center font-semibold md:font-bold text-black">Global Technology Expert & Innovation Leader</p>
                                <div className="mt-5 md:flex md:justify-left md:items-center">
                                    <p className="md:text-lg text-sm font-normal px-4 md:px-0 md:font-bold text-slate-500 md:tracking-wide md:leading-relaxed md:mr-10">A Strategic & Achievement-oriented
                                        passionate leader, offering 27 years of rich
                                        & multi-functional experience with strong technology & business development
                                        skills and broad multinational experience in delivering IT solutions across
                                        the enterprise by leveraging deep Technology, Innovation, IT advisory
                                        and Hands-On experience.</p>
                                    <img
                                        className="object-scale-down mt-0 h-32 w-32 ml-5 md:block hidden"
                                        src="https://i.ibb.co/Tkm6kdB/pfp.png"
                                        alt="Profile" />
                                </div>
                            </span>
                        </div>
                    </div>
                    <img
                        className="mr-10 h-96 w-96 sm:h-full md:h-full hidden "
                        src="https://i.ibb.co/515yxzB/Founder1.png"
                        alt="IT Expert"
                    />
                </div>


                {/* Icons */}

                <div className=" justify-end pt-20 gap-2 pr-10 hidden">
                    <a href="https://www.instagram.com/drastic_coder/" className="">
                        <img
                            alt="instagram"
                            src="https://i.ibb.co/BwmjsLB/instagram.png"
                            className=" transition ease-in-out   hover:scale-75  duration-1"
                        ></img>
                        <span className="sr-only">instagram page</span>
                    </a>
                    <a href="https://www.instagram.com/drastic_coder/">
                        <img
                            alt="Facebook"
                            src="https://i.ibb.co/c8nkskK/facebook.png"
                            className="transition ease-in-out   hover:scale-75  duration-10"
                            ></img>
                        <span className="sr-only">facebook page</span>
                    </a>
                    <a href="https://www.instagram.com/drastic_coder/">
                        <img
                            alt="telegram"
                            src="https://i.ibb.co/T8YTjmF/telegram.png"
                            className="transition ease-in-out   hover:scale-75  duration-10"
                        ></img>
                        <span className="sr-only">telegram page</span>
                    </a>
                    <a href="https://www.instagram.com/drastic_coder/">
                        <img
                            alt="in"
                            src="https://i.ibb.co/YZBFK1h/in.png"
                            className="transition ease-in-out   hover:scale-75  duration-10"
                        ></img>
                        <span className="sr-only">in page</span>
                    </a>
                    <a href="https://www.instagram.com/drastic_coder/">
                        <img
                            alt="twitter"
                            src="https://i.ibb.co/d0mY9Zp/twitter.png"
                            className="transition ease-in-out hover:scale-75  duration-10"
                        ></img>
                        <span className="sr-only">twitter page</span>
                    </a>
                </div>
                <footer className="lg:m-4 bg-[#C5D4F2] md:p-3 sm:p-2 rounded-3xl">
                <div className="md:flex md:justify-between">
                    <div>
                        <img src="https://i.ibb.co/NNgmSDY/footer-img.png" className="hidden lg:block md:block lg:px-8 md:pr-5 lg:h-60 lg:w-96 md:h-48 md:w-96" alt="footer-img" />
                    </div>
                    <div className="lg:h-full lg:w-full md:w-full md:h-full">
                        <img src="https://i.ibb.co/R9cKZRv/Group-27.png" className="lg:w-64 md:w-48 w-32 px-3" alt="logo"></img>
                        <div className="lg:pb-1 md:pb-4 mx-auto">
                            <div className="select-none lg:text-lg md:text-sm text-[11px] text-gray-500 px-5">
                                502 GPM, Bandra Kherwadi East
                                <p className="select-none lg:text-lg md:text-sm text-[11spx] text-gray-500">Mumbai -400001</p>
                            </div>
                        </div>
                        <div className="grid grid-cols-3 gap-4 text-center justify-between pt-2 lg:pt-0">
                            <div>
                                <ul className="text-gray-600 lg:text-lg md:text-xs md:leading-5 text-[11px]">
                                    <li>
                                        <a href="/about" className="hover:underline">About Us</a>
                                    </li>
                                    <li >
                                        <a href="https://modernsolnhub.com/page/contact-h8km3" className="select-none hover:underline">Contact
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://modernsolnhub.com/page/internship-r6npio" className="hover:underline">Internship</a>
                                    </li>
                                </ul>
                            </div>
                            <div>
                                <ul className="text-gray-600 lg:text-lg md:text-xs md:leading-5 text-[11px]">
                                    <li >
                                        <a href="https://modernsolnhub.com/page/microservices-certification-qw546f" className="hover:underline">Certification</a>                                   </li>
                                    <li >
                                        <a href="/Dashboard" className="hover:underline">Home</a>
                                    </li>
                                    <li>
                                        <a href="https://modernsolnhub.com/" className="hover:underline">ModernSolHub</a>                                   </li>
                                </ul>
                            </div>
                            <div>
                                <ul className="text-gray-600 lg:text-lg md:text-xs md:leading-5 text-[11px]">
                                    <li>
                                        <a href="/know-more" className="hover:underline">Know More</a>
                                    </li>
                                    <li >
                                        <a href="https://modernsolnhub.com/page/our-leaders-h8km3" className="hover:underline">Leaders</a>
                                    </li>
                                    <li>
                                        <a href="https://modernsolnhub.com/page/student-to-smart-it-professional-masterclass" className="hover:underline">Course</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* <hr className=" border-gray-200 sm:mx-auto lg:mb-2" /> */}
                    <div className=" mb-2 flex gap-2 sm:mt-3 lg:pr-5 md:pr-5 md:w-96 w-32 pb-2 h-8 pt-2 justify-center mx-auto">
                        <a href="https://www.instagram.com/haresh_kurade_729/" className="lg:mt-[11.5rem] md:mt-[9.5rem]">
                            <img
                                alt="instagram"
                                src="https://i.ibb.co/BwmjsLB/instagram.png"
                                className=" transition ease-in-out   hover:scale-75  duration-1"
                            ></img>
                            <span className="sr-only">instagram page</span>
                        </a>
                        <a href="https://www.facebook.com/haresh.kurade.729/" className="lg:mt-[11.5rem] md:mt-[9.5rem]">
                            <img
                                alt="Facebook"
                                src="https://i.ibb.co/c8nkskK/facebook.png"
                                className="transition ease-in-out   hover:scale-75  duration-10"
                            ></img>
                            <span className="sr-only">facebook page</span>
                        </a>
                        <a href="https://web.telegram.org/k/#@Haresh_Kurade_729" className="lg:mt-[11.5rem] md:mt-[9.5rem]">
                            <img
                                alt="telegram"
                                src="https://i.ibb.co/T8YTjmF/telegram.png"
                                className="transition ease-in-out   hover:scale-75  duration-10"
                            ></img>
                            <span className="sr-only">telegram page</span>
                        </a>
                        <a href="http://www.linkedin.com/in/haresh-kurade-22a04b241" className="lg:mt-[11.5rem] md:mt-[9.5rem]">
                            <img
                                alt="in"
                                src="https://i.ibb.co/YZBFK1h/in.png"
                                className="transition ease-in-out   hover:scale-75  duration-10"
                            ></img>
                            <span className="sr-only">in page</span>
                        </a>
                        <a href="https://twitter.com/" className="lg:mt-[11.5rem] md:mt-[9.5rem]">
                            <img
                                alt="twitter"
                                src="https://i.ibb.co/d0mY9Zp/twitter.png"
                                className="transition ease-in-out hover:scale-75  duration-10"
                            ></img>
                            <span className="sr-only">twitter page</span>
                    
                        </a>
                    </div>
                </div>
            </footer>
            </div>
        </div>
    </section>
    )
}

export default AboutUs5;